export const environment = {
  production: false,
  apiUrl: '',
  platformUrl: 'https://platform.test1.tive.com',
  auth0: {
    domain: 'login.test1.tive.com',
    clientId: 'VXQ1FuQqXkIJjIJuejT67Vtl40vEJTPn',
    audience: 'https://platform.test1.tive.io/',
  },
};
